import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { OktaAuthService } from '../services/okta-auth.service';

@Component({
    selector: 'app-callback',
    template: '<p>{{ "auth.callback.processing" | translate }}</p>',
    imports: [TranslateModule]
})
export class CallbackComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly oktaAuthService: OktaAuthService
    ) {}

    ngOnInit(): void {
        void this.handleCallback();
    }

    private async handleCallback(): Promise<void> {
        try {
            const hasValidTokens = await this.oktaAuthService.handleCallback();
            await this.router.navigate([hasValidTokens ? '/main' : '/login']);
        } catch {
            await this.router.navigate(['/login']);
        }
    }
}
